import { render, staticRenderFns } from "./StudentHomeworkApprove.vue?vue&type=template&id=1d17e738&scoped=true&"
import script from "./StudentHomeworkApprove.vue?vue&type=script&lang=js&"
export * from "./StudentHomeworkApprove.vue?vue&type=script&lang=js&"
import style0 from "./StudentHomeworkApprove.vue?vue&type=style&index=0&id=1d17e738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d17e738",
  null
  
)

export default component.exports